import { v4 as uuidv4 } from 'uuid';
import stores from '@/stores';

const initConfig = {
    delay: 2500
};

export default {
    info(text, config = {}) {
        stores.messages().setMessages({
            type: 'info',
            text,
            config: {
                ...initConfig,
                ...config
            },
            id: uuidv4()
        });
    },
    success(text, config = {}) {
        stores.messages().setMessages({
            type: 'success',
            text,
            config: {
                ...initConfig,
                ...config
            },
            id: uuidv4()
        });
    },
    error(text, config = {}) {
        stores.messages().setMessages({
            type: 'error',
            text,
            config: {
                ...initConfig,
                ...config
            },
            id: uuidv4()
        });
    }
};
